import React from "react";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client"
import App from "./App";

import "bootstrap/dist/css/bootstrap.css";

import "./style/utilities.css";
import "./style/hero.css";
import "./style/featured.css";
import "./style/footer.css";
import "./style/bookcenter.css";
import "./style/home.css";
import "./style/map.css";
import "./style/VisionMision.css";
import "./style/cooperators.css";


// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById("root")
// );

const container = document.getElementById('root');
const root = createRoot(container); 
root.render(<App />); 